export const words = {
    technicalSupport:"技术支持 J2mvc",
    index:"首页",
    home:"首页",
    email:{
        label:"邮箱",
        placeholder:"邮箱格式如master@j2mvc.com"
    },
    username:{
        label:"用户名",
        placeholder:"用户名/手机号/邮箱"
    },
    password:{
        label:"密码",
        placeholder:"******"
    },
    identifyCode:{
        label:"验证码",
        placeholder:"请输入验证码"
    },
    loadingText:{
        login:"正在提交登录...",
        submit:"正在提交数据...",
        goIndex:"正在跳转管理界面..."
    },
    keyword:{
        label:'关键字',
        placeholder:'关键字搜索...',
    },
    catName:{
        label:"分类名称",
        placeholder:"请输入分类名称"
    },
    catAlias:{
        label:"分类别名",
        placeholder:"请输入分类别名"
    },
    catAddress:{
        label:"访问地址",
        placeholder:"请输入访问地址,由字母数字_-组成"
    },
    title:{
        label:"标题",
        placeholder:"请输入标题"
    },
    linkAddress:{
        label:"链接地址",
        placeholder:"链接地址以http://或https://开头"
    },
    sorter:"排序",
    status:"状态",
    on:"启用",
    off:"禁用",
    chooseImage:"选择图片",
    chooseFile:"选择文件",
    catIcon:"分类图标",
    uploadFile:"上传文件",
    uploadImage:"上传图片",
    uploadImages:"上传多张图片",
    uploadDrag:"拖拽文件到此处上传，或点击上传",
    uploadSubmit:"提交上传",
    insertAll:"全部插入",
    insertImage:"插入图片",
    insertSelected:"插入选中",
    insert:"插入",
    removeSelected:"删除选中",
    chooseAll:"选择全部",
    sure:"确定",
    refresh:"刷新",
    prevPage:"上一页",
    nextPage:"下一页",
    modify:"修改",
    modifyCat:"修改分类",
    append:"添加",
    appendCat:"添加分类",
    appendChildCat:"添加下级分类",
    removeCat:"删除分类",
    messages:"消息",
    profile:"账户设置",
    desc:"倒序",
    asc:"升序",
    account:"我的账户",
    notify:"最新消息",
    mailbox:"我的邮件",
    rememberMe:"记住我",
    close:"关闭当前页面",
    closeAll:"关闭所有页面",
    signIn:"登录",
    logout:"退出",
    forgot:"忘记密码?",
    signUpTip:`没有帐户?点击注册`,
    submit:"提交",
    cancel:"取消",
    subscribe:"订阅",
    editGroupTip:"创建附件分组，以便方便查询...",
    addGroup:"添加分组",
    editGroup:"编辑分组",
    groupName:"分组名称",
    removeGroup:"删除分组",
    ungrouped:"未分组",
    localUpload:"本地上传",
    remoteFiles:"远程文件",
    fileLinks:"文件链接",
    removePictures:"远程图片",
    picturesLinking:"图片链接",
    moveToGroup:"移动到分组",
    uploadToGroup:"上传到分组",
    reset:"重置",
    clear:"清除",
    add:"添加",
    mode:"修改",
    edit:"编辑",
    remove:"删除",
    removeBatch:"批量删除",
    all:"全部",
    list:"列表",
    whole:"全局",
    global:"全局",
    create:"创建",
    search:"搜索",
    link:"链接",
    scroll:"滚动",
    setting: "设置",
    manager:"管理",
    content:"内容",
    area: "行政区划",
    client:"客户端",
    common:"公共",
    ad: "广告",
    board: "留言",
    module: "模块",
    document:"文档",
    article: "文章",
    cat: "分类",
    table: "表格",
    shopping: "商城",
    product: "商品",
    productCat:"商品分类",
    chooseCat: "选择分类",
    attr: "属性",
    spec: "规格",
    promotion: "促销活动",
    activity: "活动",
    coupon: "优惠券", 
    freight: "运费",
    icon: "图标", 
    trade: "交易",
    children: "子集",
    order: "订单",
    delivery: "发货", 
    integral: "积分",
    solid: "实心",
    exchange: "兑换", 
    interact: "互动",
    comment: "评论",
    share: "分享", 
    like: "点赞",
    collect: "收藏",
    stat: "统计",
    analysis: "分析",
    ui: "UI",
    nav: "导航",
    navbar: "导航栏", 
    layout: "布局",
    page: "页面", 
    view: "控件",
    item: "条目",
    typography: "排版",
    component:"组件",
    user: "用户",
    write: "输入",
    width:"宽",
    height:"高",
    alert:{
        tips:"提示",
        warning:"警告",
        disagree:"不同意",
        agree:"同意",
        sure:"确定",
        cancel:"取消"
    },
    fullScreen:"全屏",
    fullScreenExit:"退出全屏",
    loadListData:"正在加载列表数据...",
    removeTips:"您正在删除文件，这会影响文件关联的内容!",
    removeAsk:"此操作不可恢复，确定要继续么？",
    removingAttch:"正在删除附件...",
    movingAttach:"正在移动附件...",
    saving:"正在保存分组...",
    removingItem:"正在移除条目...",
    uploaded:"上传完毕",
    uploading:"正在上传...",
    uploadingNoEllipsis:"正在上传",
    waitUpload:"等待上传.",
    removeGroupTips:"您正在删除附件分组，当前文件将移动到未分组!",
    onceMastFile:"只能选择一个文件",
    image:"图片",
    file:"文件"
}
